import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Home from './pages/home/home';
import GlobalBackground from './components/GlobalBackground';
import Register from './pages/home/register/Register';
import Login from './pages/home/login/login';
import ProfilesPage from './pages/profiles/profile';
import { ThemeProvider } from './components/theme/ThemeContext';
import { AuthProvider, useAuth } from './components/auth/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Header from './components/Header';
import AdminPage from './pages/0admin/0admin';
import { I18nProvider } from '@/i18n';

const API_BASE = (((import.meta as any).env?.VITE_API_URL) || (typeof window !== 'undefined' ? window.location.origin : '')).replace(/\/+$/, '');

function App() {
  const [apiStatus, setApiStatus] = useState<'loading' | 'online' | 'offline'>('loading');

  useEffect(() => {
    const checkApiHealth = async () => {
      try {
        const response = await fetch(`${API_BASE}/health`, { credentials: 'include' });
        if (response.ok) {
          setApiStatus('online');
        } else {
          setApiStatus('offline');
        }
      } catch (error) {
        setApiStatus('offline');
      }
    };

    checkApiHealth();
  }, []);

  const statusColor = {
    loading: '#6b7280', // gray-500
    online: '#16a34a',  // green-600
    offline: '#dc2626', // red-600
  }[apiStatus];

  const AppShell: React.FC = () => {
    const location = useLocation();
    const hideHeader = location.pathname.startsWith('/profile');
    const CatchAll: React.FC = () => {
      const { user } = useAuth();
      return user ? <Navigate to="/profiles/my-requests" replace /> : <Navigate to="/" replace />;
    };
    return (
      <>
        {!hideHeader && <Header />}
        <GlobalBackground />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/0admin" element={<AdminPage />} />
          <Route path="/profile" element={<Navigate to="/profiles/my-requests" replace />} />
          <Route path="/profiles" element={<Navigate to="/profiles/my-requests" replace />} />
          <Route
            path="/profiles/:panel"
            element={
              <ProtectedRoute>
                <ProfilesPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<CatchAll />} />
        </Routes>
      </>
    );
  };

  return (
    <AuthProvider>
      <I18nProvider>
        <ThemeProvider>
          <BrowserRouter>
            <AppShell />
          </BrowserRouter>
        </ThemeProvider>
      </I18nProvider>
    </AuthProvider>
  );
}

export default App;
